import React, { useState } from 'react';
import { Card, Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { requestPasswordReset } from '../../services/auth';

const ForgotPassword = () => {
  const [requestStatus, setRequestStatus] = useState('');
  const [requestMessage, setRequestMessage] = useState('');

  // We don't redirect authenticated users to allow password reset even with active session

  // Validation schema
  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required')
  });

  // Initial form values
  const initialValues = {
    email: ''
  };

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setRequestStatus('');
    setRequestMessage('');

    try {
      await requestPasswordReset(values.email);
      setRequestStatus('success');
      setRequestMessage('If an account exists with this email, you will receive password reset instructions.');
      resetForm();
    } catch (error) {
      console.error('Password reset request error:', error);
      setRequestStatus('error');
      setRequestMessage('An error occurred while processing your request. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm border-0 my-5">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Forgot Password</h2>
                <p className="text-muted">
                  Enter your email address and we'll send you instructions to reset your password.
                </p>
              </div>

              {requestStatus === 'success' && (
                <Alert variant="success" className="mb-4">
                  {requestMessage}
                </Alert>
              )}

              {requestStatus === 'error' && (
                <Alert variant="danger" className="mb-4">
                  {requestMessage}
                </Alert>
              )}

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && errors.email}
                        placeholder="Enter your email address"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 py-2 mb-3"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send Reset Instructions'}
                    </Button>

                    <div className="text-center">
                      <Link to="/login" className="text-decoration-none">
                        Back to Login
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
